import React, { useEffect, useState } from "react";
import { Switch } from "react-router-dom";
import { RouteWithSubRoutes } from "../../config/Router";
import BackGround from "../../assets/img/background.png";
import { resetInfo } from "../../actions/userActions";
import { logout } from "../../actions/authActions";
import { connect } from "react-redux";
import { getUserInfo } from "../../actions/userActions";

import inMemoryJWT from "../../auth/inMemoryJwt";
import socketLogic from "../../sockets/sockets";
import { addMessage } from "../../actions/messagesActions";
import { addNotification } from "../../actions/notificationsActions";
import inMemoryJwt from "../../auth/inMemoryJwt";
import Navbar from "../../containers/Navbar/Navbar/Navbar";
import localStorage from "../../utils/hooks/useLocalStorage";

const RootUser = ({
  addNotification,
  routes,
  getUserInfo,
}) => {

  const [, setNotification] = useState(0);


  useEffect(() => {
    socketLogic.listenAllEvents("private-message", () => {
      console.log();
      //addMessage(res, false, true);
    });
    socketLogic.listenAllEvents("notification", (res) => {
      console.log();
      addNotification(res);
    });
  }, []);

  useEffect(() => {
    if (!inMemoryJwt.getToken()) {
      inMemoryJWT.getRefreshedToken(  );
    }
    inMemoryJWT.waitForTokenRefresh().then(() => {
      // opener información del usuario aunque este en otro rol
      getUserInfo(localStorage().getItem("idUser"));
    });
  }, []);

  return (
    <div>
      <img
        className="background-root"
        src={BackGround}
        alt="imagen de login"
      ></img>
      <Navbar isHome={true} setNotification={setNotification} />
      <Switch>
        {routes.map((route, i) => (
          <RouteWithSubRoutes key={i} {...route} />
        ))}
      </Switch>
      
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo.userInfo,
  };
};
export default connect(mapStateToProps, {
  logout,
  resetInfo,
  addMessage,
  addNotification,
  getUserInfo,
})(RootUser);
